export default __webpack_public_path__ + "static/layer783-e8e99b18ac17304c0d73a9562953a1a2.jpg";